if (!Number.prototype.toPrice) {
  // eslint-disable-next-line
  Number.prototype.toPrice = function () {
    return String(this).replace(/\d(?=(\d{3})+$)/g, '$&,');
  };
}
